import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonSecondaryMedium } from "../../generic/common/ButtonSecondaryMedium";
import { CurrencyFormat } from "../../generic/currency-format/CurrencyFormat";
import { TextLoca } from "../../generic/text/TextLoca";
export var OfferButtonBuy = function (_a) {
    var shopPackage = _a.shopPackage, idLocaKay = _a.idLocaKay, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    if (shopPackage == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var locaId = idLocaKay ? idLocaKay : IdLoca.buy;
    return (React.createElement(ButtonSecondaryMedium, { onClick: onClick, disabled: disabled },
        React.createElement("div", { className: "flex flex--stacked flex--guts w100" },
            React.createElement("div", { className: IdStyles.TextButtonHeading },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: locaId })),
            React.createElement("div", { className: IdStyles.ButtonDivider }),
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement("div", null,
                    React.createElement(CurrencyFormat, { amount: shopPackage.price || 0, currencyCode: shopPackage.currencyCode || "", className: IdStyles.TextBoldSecondary + " line-height-30" }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferButtonBuy.tsx
// module id = 447
// module chunks = 3